import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import {SupportProduct} from "./SupportProduct";

export class Support implements Serializable {
    id: string;
    code: string;
    orderNumber: string;
    createdBy: string;
    creationDate: Date;
    collectedBy: string;
    collectionDate: Date;
    droppedOffBy: string;
    dropOffDate: Date;
    dropOffLocation: string;
    plannedSlot: Date;
    collectionSlot: Date;
    supportStatus: SupportStatus;
    storeId: string;
    driveId: string;
    deliveryType: string;
    zoneCode: string;
    products: SupportProduct[];

    fromJSON(rawObject: any) {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, []);
    }
}

export enum SupportStatuses {
    CREATED = 'CREATED',
    TO_COLLECT = 'TO_COLLECT',
    COLLECTED = 'COLLECTED',
    DROPPED_OFF = 'DROPPED_OFF'
}

export const SUPPORT_STATUS_ORDER: Record<SupportStatuses, number> = {
    [SupportStatuses.CREATED]: 1,
    [SupportStatuses.TO_COLLECT]: 2,
    [SupportStatuses.COLLECTED]: 3,
    [SupportStatuses.DROPPED_OFF]: 4
};

export type SupportStatus = SupportStatuses.CREATED
  | SupportStatuses.TO_COLLECT
  | SupportStatuses.COLLECTED
  | SupportStatuses.DROPPED_OFF;